import React from 'react';
//import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';
import { withAuthDomain } from '../../components/Session';
import withWidth from '@material-ui/core/withWidth'
//import AppointmentPage from '../Appointment';

//import { makeStyles } from '@material-ui/core/styles';
//import Autocomplete from '@material-ui/lab/Autocomplete';
//import TextField from '@material-ui/core/TextField';
//import Typography from '@material-ui/core/Typography';
//import CircularProgress from '@material-ui/core/CircularProgress';
//import { Button } from '@material-ui/core';
//import MapContainer from '../../components/Map/MapContainer'
//import MapDialog from '../../components/Map/MapDialog'
//import Map from '../../components/Map/MapComponent'

import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
//import InboxIcon from '@material-ui/icons/MoveToInbox';
//import MailIcon from '@material-ui/icons/Mail';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
//import RestoreIcon from '@material-ui/icons/Restore';
//import FavoriteIcon from '@material-ui/icons/Favorite';
//import LocationOnIcon from '@material-ui/icons/LocationOn';
import Tooltip from '@material-ui/core/Tooltip';
import ChatIcon from '@material-ui/icons/Chat';
import InfoIcon from '@material-ui/icons/Info';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HomeIcon from '@material-ui/icons/Home';
//import SyncAltIcon from '@material-ui/icons/SyncAlt';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Clock,{twoDigits} from '../../components/Fragment/Clock.js'
/*
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MapIcon from '@material-ui/icons/Map';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import RestorePageIcon from '@material-ui/icons/RestorePage';
*/
//import AccountPage from '../Account';

//import AppointmentPage from '../Appointment';
//import DisplayPage from '../Display';
//import SAPage from '../SA';
//import HistoryPage from '../History';
//import MapPage from '../Map';
//import BoardPage from '../Board';
//import InputJPCBPage from '../InputJPCB';
//import RecoveryPage from '../Recovery';

import DashboardPage from '../Dashboard';

import CompanySettingsPage from '../CompanySettings';
import BranchSettingsPage from '../BranchSettings';
import DomainSettingsPage from '../DomainSettings';
import CompanyBillingsPage from '../CompanyBillings';

import SecureBillingsPage from '../SecureBillings';

//import AdminPage from '../Admin';

//import BranchSettingsPage from '../Branch';
//import AdsSettingsPage from '../AdsSettings';
import { Button } from '@material-ui/core';
/*
const AppointmentPage = React.lazy(()=> import('../Appointment'))
const DisplayPage = React.lazy(()=> import('../Display'))
const SAPage = React.lazy(()=> import('../SA'))
const MapPage = React.lazy(()=> import('../Map'))
const BoardPage = React.lazy(()=> import('../Board'))
const InputJPCBPage = React.lazy(()=> import('../InputJPCB'))
const RecoveryPage = React.lazy(()=> import('../Recovery'))
*/
const drawerWidth = "240px";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor:"#efefef",
    display: 'flex',
  },
  rootMobile: {
    backgroundColor:"#efefef",
    display: 'block',
  },
  
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth})`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerMobile:{
    width: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    
    //padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    
    //padding: theme.spacing(3),
  },

  bottomNavigation: {
    width: "100%",
    margin:"auto",
    position: "fixed",
    bottom:0,
  }
}));

const HomePage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    width,
    //...otherProps
  }=props

  React.useEffect(()=>{
    window.location.hash="no-back-button"
    window.location.hash="no-back-button"
    window.onhashchange=function(){window.location.hash="no-back-button"}
  },[1])

  const classes = useStyles();
  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [title, setTitle] = React.useState("Online Asset Manager");
  const [subTitle, setSubTitle] = React.useState("Test");
  

  const [viewFagment, setViewFragment] = React.useState("home");

  const [valueBottomNavigation, setValueBottomNavigation] = React.useState(0);

  const [serverMillis,setServerMillis]=React.useState(0)//millis
  const [serverClockStatus,setServerClockStatus]=React.useState(0)//0=init,1=ok,2=err,3=forbidden
  const [currentDate,setCurrentDate]=React.useState("")

  const [ownCompanies,setOwnCompanies]=React.useState([])
  const [activeCompanyId,setActiveCompanyId]=React.useState("")
  const [activeCompany,setActiveCompany]=React.useState()

  React.useEffect(()=>{
    if(!!activeCompanyId){
      return firebase.fs.doc("companies/"+activeCompanyId).onSnapshot((doc) => {
        setActiveCompany(doc.data())
      },(e)=>{
        setActiveCompany(null)
        console.log("error get company : "+e)
      })
    }else{
      setActiveCompany(null)
    }
  },[activeCompanyId])

  React.useEffect(()=>{
    if(!!activeCompany){
      setSubTitle(activeCompany.name)
      setActiveCompanyId(activeCompany.id)
    }else{
      setSubTitle("")
      setActiveCompanyId("")
    }
  },[activeCompany])
  
  React.useEffect(()=>{
    if(sessionDomain>=1&&!!currentUser&&!!currentUser.id){
      return firebase.fs.collection("companies").where("owner", "==", currentUser.id).onSnapshot((querySnapshot) => {
        var companies = [];
        querySnapshot.forEach(function(doc) {
          companies.push(doc.data());
        });
        setOwnCompanies(companies)
        //console.log()
      },(e)=>{
        console.log("error get company list"+e)
      })
    }
  },[firebase,currentUser,sessionDomain])
  
  const [anchorElSwitchCompany, setAnchorElSwitchCompany] = React.useState(null);
  function SwitchCompany(event){
    if(ownCompanies.length>=2){
      setAnchorElSwitchCompany(event.currentTarget);
    }
  }
  
  const handleSwitchCompany = (company) => {
    setActiveCompany(company)
    handleCloseSwitchCompany()
  };

  const handleCloseSwitchCompany =()=>{
    setAnchorElSwitchCompany(null);
  }

/*
{enabled:true,
    adsList:[
    {id:"0",
      enabled:true,
      videoUrl:"https://firebasestorage.googleapis.com/v0/b/online-asset-manager.appspot.com/o/companies%2FiYYW1UR9pt8DGahESs35%2Fbranches%2FiYYW1UR9pt8DGahESs35%2Fe-jpcb%2Fads1.mp4?alt=media&token=6f93ca3d-fb5a-45c7-9169-83ede4cdaf74",
      imageUrl:"https://firebasestorage.googleapis.com/v0/b/online-asset-manager.appspot.com/o/companies%2FiYYW1UR9pt8DGahESs35%2Fbranches%2FiYYW1UR9pt8DGahESs35%2Fe-jpcb%2Fads1.png?alt=media&token=03e3478e-10ed-455f-bd58-0becb9b41b3f",
      text:"Gunakan Appointment untuk menghindari antrian",
      link:"e-jpcb.web.app/display",
      imageDuration:5000,
    },
    {id:"1",
      enabled:true,
      videoUrl:"https://firebasestorage.googleapis.com/v0/b/online-asset-manager.appspot.com/o/companies%2FiYYW1UR9pt8DGahESs35%2Fbranches%2FiYYW1UR9pt8DGahESs35%2Fe-jpcb%2Fsumo.mp4?alt=media&token=b723ab2b-9de7-475e-aea2-64c9f3149736",
      imageUrl:"https://firebasestorage.googleapis.com/v0/b/online-asset-manager.appspot.com/o/companies%2FiYYW1UR9pt8DGahESs35%2Fbranches%2FiYYW1UR9pt8DGahESs35%2Fe-jpcb%2Fsumo.jpeg?alt=media&token=e887a0b0-d743-4207-b615-723dcc484e5e",
      text:"Dapatkan Nissan New Livina dengan diskon Sumo. Now or Never",
      link:"e-jpcb.web.app/display",
      imageDuration:5000,
    },]
  }
*/
/*
  React.useEffect(()=>{
    if(sessionDomain>=4){
      return firebase.fs.doc("companies/"+currentUser.companyViewId+"/branches/"+currentUser.branchViewId+"/features/e-jpcb").onSnapshot((configDoc) => {
        setJpcConfig(configDoc.data())
        //console.log("configDoc.data()= "+configDoc.data().enabled)
      },(e)=>{
        console.log("error "+e)
      })
    }
  },[firebase,currentUser,sessionDomain])

  React.useEffect(()=>{
    if(sessionDomain>=4){
      return firebase.fs.doc("companies/"+currentUser.companyViewId+"/branches/"+currentUser.branchViewId+"/features/ads").onSnapshot((configDoc) => {
        setAdsConfig(configDoc.data())
      },(e)=>{
        console.log("error "+e)
      })
    }
  },[firebase,currentUser,sessionDomain])
  */

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  function handleClickOpenFragment(accessText,titleText,index){
    setViewFragment(accessText)
    setTitle(titleText)
    if(width==="xs")setOpenDrawer(false);
  }

  function openHomeFragment(){
    setViewFragment("home")
    setTitle("Online Asset Manager")
    if(width==="xs")setOpenDrawer(false);
  }
  function openAccountFragment(){
    setViewFragment("account")
    setTitle(!!currentUser?currentUser.name:"Anonymous")
    if(width==="xs")setOpenDrawer(false);
  }
  function openChatFragment(){
    setViewFragment("chat")
    setTitle("Chat")
    if(width==="xs")setOpenDrawer(false);
  }
  function openAboutFragment(){
    setViewFragment("about")
    setTitle("Tentang")
    if(width==="xs")setOpenDrawer(false);
  }

  return (
    <>
    <div className={width==="xs"?classes.rootMobile:classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openDrawer,
        })}
      >
        <Toolbar >
          {sessionDomain>=1&&ownCompanies.length>=1?
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: openDrawer,
              })}
            >
              <MenuIcon />
            </IconButton>
          :null}
          
          <Typography variant="h6" noWrap style={{flexGrow:1}} onClick={SwitchCompany}>
            {title}{!!subTitle&&<div style={{margin:"0px 10px",fontSize:"14px",cursor:(ownCompanies.length>=2)?"pointer":"default"}}>{subTitle}</div>}
          </Typography>
          <Menu
            id="simple-menu"
            anchorEl={anchorElSwitchCompany}
            keepMounted
            open={Boolean(anchorElSwitchCompany)}
            onClose={handleCloseSwitchCompany}
          >
            {ownCompanies.map((company,idx)=>!!activeCompany&&activeCompany.id===company.id?null:<MenuItem key={company.id||idx} onClick={()=>handleSwitchCompany(company)}>{company.name}</MenuItem>)}
          </Menu>
          <Clock style={{float:"right",display:width==="xs"?"none":"inline"}} onDayChange={setCurrentDate} onClockTick={setServerMillis} onStatusChange={setServerClockStatus}/>
          
          
        </Toolbar>
      </AppBar>
      
      {sessionDomain>=1&&ownCompanies.length>=1?
      <SwipeableDrawer
      disableBackdropTransition={width==="xs"}
      swipeAreaWidth={10}
      variant={width==="xs"?"temporary":"permanent"}
      className={width==="xs"?
        classes.drawerMobile
        :
        clsx(classes.drawer, {
          [classes.drawerOpen]: openDrawer,
          [classes.drawerClose]: !openDrawer,
        })}
      classes={width==="xs"?{}:{
        paper: clsx({
          [classes.drawerOpen]: openDrawer,
          [classes.drawerClose]: !openDrawer,
        }),
      }}
      open={openDrawer}
      onClose={handleDrawerClose}
      onOpen={setOpenDrawer}
    >
      <div className={classes.toolbar} >
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <Divider />
      <List>
        <ListItem button onClick={openHomeFragment}>
          <Tooltip title={<span style={{fontSize:"14px"}}>Beranda</span>} placement="right"><ListItemIcon><HomeIcon color={viewFagment==="home"?"primary":"inherit"}/></ListItemIcon></Tooltip>
          <ListItemText primary={"Beranda"} primaryTypographyProps={viewFagment==="home"?{color:"primary",style:{fontWeight:"bold"}}:{}}/>
        </ListItem>
        <ListItem button onClick={openAccountFragment}>
          <Tooltip title={<span style={{fontSize:"14px"}}>Akun</span>} placement="right"><ListItemIcon><AccountCircleIcon color={viewFagment==="account"?"primary":"inherit"} /></ListItemIcon></Tooltip>
          <ListItemText primary={"Akun"} primaryTypographyProps={viewFagment==="account"?{color:"primary",style:{fontWeight:"bold"}}:{}} />
        </ListItem>
        
      </List>
      <Divider />
      {!!activeCompany&&
      <>
        <List>
          {["online-asset-manager.company-settings","online-asset-manager.branch-settings",
          "online-asset-manager.domain-settings","online-asset-manager.company-billings"
          ].map((accessName, index) => {
            var accessTitle=ROLES.getTitleByAccessName(accessName)
            var accessIcon=ROLES.getIconByAccessName(accessName)
            if(accessTitle==="unknown"||accessTitle===""||!accessIcon||accessIcon==="UnknownIcon")return null
            return (
              <ListItem button key={accessName} onClick={()=>{handleClickOpenFragment(accessName,accessTitle,index)}}>
                <Tooltip title={<span style={{fontSize:"14px"}}>{accessTitle}</span>} placement="right"><ListItemIcon>{React.createElement(accessIcon,{color:viewFagment===accessName?"primary":"inherit"})}</ListItemIcon></Tooltip>
                <ListItemText primary={accessTitle} primaryTypographyProps={viewFagment===accessName?{color:"primary",style:{fontWeight:"bold"}}:{}} />
            </ListItem>
          )})}
        </List>
        <Divider />
      </>
      }
      {!!activeCompany&&activeCompany.id==="ac3EACTv0xY4StfsGPte"&&
      <>
        <List>
          {["online-asset-manager.secure.users","online-asset-manager.secure.tokens",
          "online-asset-manager.secure.mobile-apps","online-asset-manager.secure.machines",
          "online-asset-manager.secure.companies","online-asset-manager.secure.billings",
          "online-asset-manager.secure.domains"
          ].map((accessName, index) => {
            var accessTitle=ROLES.getTitleByAccessName(accessName)
            var accessIcon=ROLES.getIconByAccessName(accessName)
            if(accessTitle==="unknown"||accessTitle===""||!accessIcon||accessIcon==="UnknownIcon")return null
            return (
              <ListItem button key={accessName} onClick={()=>{handleClickOpenFragment(accessName,accessTitle,index)}}>
                <Tooltip title={<span style={{fontSize:"14px"}}>{accessTitle}</span>} placement="right"><ListItemIcon>{React.createElement(accessIcon,{color:viewFagment===accessName?"primary":"inherit"})}</ListItemIcon></Tooltip>
                <ListItemText primary={accessTitle} primaryTypographyProps={viewFagment===accessName?{color:"primary",style:{fontWeight:"bold"}}:{}} />
            </ListItem>
          )})}
        </List>
        <Divider />
      </>
      }
      <List>
        <ListItem button onClick={openChatFragment}>
          <Tooltip title={<span style={{fontSize:"14px"}}>Pertanyaan</span>} placement="right"><ListItemIcon><ChatIcon color={viewFagment==="chat"?"primary":"inherit"}/></ListItemIcon></Tooltip>
          <ListItemText primary={"Pertanyaan"} primaryTypographyProps={viewFagment==="chat"?{color:"primary",style:{fontWeight:"bold"}}:{}} />
        </ListItem>
        <ListItem button onClick={openAboutFragment}>
          <Tooltip title={<span style={{fontSize:"14px"}}>Tentang</span>} placement="right"><ListItemIcon><InfoIcon color={viewFagment==="about"?"primary":"inherit"} /></ListItemIcon></Tooltip>
          <ListItemText primary={"Tentang"} primaryTypographyProps={viewFagment==="about"?{color:"primary",style:{fontWeight:"bold"}}:{}} />
        </ListItem>
        <ListItem button onClick={()=>{firebase.doSignOut()}}>
          <Tooltip title={<span style={{fontSize:"14px"}}>Keluar</span>} placement="right"><ListItemIcon><PowerSettingsNewIcon color={viewFagment===""?"primary":"inherit"} /></ListItemIcon></Tooltip>
          <ListItemText primary={"Keluar"} primaryTypographyProps={viewFagment===""?{color:"primary",style:{fontWeight:"bold"}}:{}} />
        </ListItem>
        
      </List>
      
    </SwipeableDrawer>
    :
    <BottomNavigation
      style={{zIndex:9999}}
      value={valueBottomNavigation}
      onChange={(event, newValue) => {
        setValueBottomNavigation(newValue);
      }}
      showLabels
      className={classes.bottomNavigation}
    >
      <BottomNavigationAction label="Beranda" icon={<HomeIcon />} onClick={openHomeFragment}/>
      <BottomNavigationAction label="Akun" icon={<AccountCircleIcon />} onClick={openAccountFragment} />
    </BottomNavigation>
    }

      <main className={classes.content}>
        <div className={classes.toolbar} />
        {viewFagment==="home"?
          <DashboardPage firebase={firebase} setActiveCompanyId={setActiveCompanyId} activeCompany={activeCompany} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus} ownCompanies={ownCompanies}/>
        :viewFagment==="account"?viewFagment
          /*<AccountPage asFragment={true} firebase={firebase}/>*/
        :viewFagment==="online-asset-manager.company-settings"?
          <CompanySettingsPage firebase={firebase} activeCompany={activeCompany} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus} />
        :viewFagment==="online-asset-manager.branch-settings"?
          <BranchSettingsPage firebase={firebase} activeCompany={activeCompany} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus} />
        :viewFagment==="online-asset-manager.domain-settings"?
          <DomainSettingsPage firebase={firebase} activeCompany={activeCompany} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus} />
        :viewFagment==="online-asset-manager.company-billings"?
          <CompanyBillingsPage firebase={firebase} activeCompany={activeCompany} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus} />
        :viewFagment==="online-asset-manager.secure.users"?viewFagment
          /*<MapPage asFragment={true} firebase={firebase} dutyConfig={dutyConfig} adsConfig={adsConfig} jpcConfig={jpcConfig} activeUnitEntries={activeUnitEntries} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus}/>*/
        :viewFagment==="online-asset-manager.secure.tokens"?viewFagment
          /*<BoardPage asFragment={true} firebase={firebase} dutyConfig={dutyConfig} adsConfig={adsConfig} jpcConfig={jpcConfig} activeUnitEntries={activeUnitEntries} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus}/>*/
        :viewFagment==="online-asset-manager.secure.mobile-apps"?viewFagment
          /*<InputJPCBPage asFragment={true} firebase={firebase} dutyConfig={dutyConfig} adsConfig={adsConfig} jpcConfig={jpcConfig} activeUnitEntries={activeUnitEntries} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus}/>*/
        :viewFagment==="online-asset-manager.secure.machines"?viewFagment
          /*<AdminPage asFragment={true} firebase={firebase} dutyConfig={dutyConfig} adsConfig={adsConfig} jpcConfig={jpcConfig} activeUnitEntries={activeUnitEntries} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus}/>*/
        :viewFagment==="online-asset-manager.secure.companies"?viewFagment
          /*<AdsSettingsPage asFragment={true} firebase={firebase} dutyConfig={dutyConfig} adsConfig={adsConfig} jpcConfig={jpcConfig} activeUnitEntries={activeUnitEntries} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus}/>*/
        :viewFagment==="online-asset-manager.secure.billings"?
          <SecureBillingsPage firebase={firebase} activeCompany={activeCompany} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus} />
        :viewFagment==="online-asset-manager.secure.domains"?viewFagment
          /*<BranchSettingsPage asFragment={true} firebase={firebase} dutyConfig={dutyConfig} adsConfig={adsConfig} jpcConfig={jpcConfig} activeUnitEntries={activeUnitEntries} currentDate={currentDate} serverMillis={serverMillis} serverClockStatus={serverClockStatus}/>*/
        :viewFagment==="chat"?
          viewFagment
        :viewFagment==="about"?
          "Tentang"
        :null
        }
      </main>
    </div>
    </>
  );
}

/*

const useStyles = makeStyles(theme => ({
  root: {
    
  },
}));

const HomePage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    //...otherProps
  }=props
  const classes = useStyles();
 

  const [openCompany, setOpenCompany] = React.useState(false);
  const [successLoadCompany,setSuccessLoadCompany] =  React.useState(false);
  const [listCompanies, setListCompanies] = React.useState([]);
  const loadingCompany = !successLoadCompany && openCompany && listCompanies.length === 0;
  const [companySelected, setCompanySelected] = React.useState(companyView);
  const [textCompanySelected, setTextCompanySelected] = React.useState((!!companyView?companyView.name +" - "+companyView.id:""));
  
  const [openBranch, setOpenBranch] = React.useState(false);
  const [successLoadBranch,setSuccessLoadBranch] =  React.useState(false);
  const [listBranches, setListBranches] = React.useState([]);
  const loadingBranch = !successLoadBranch && openBranch && listBranches.length === 0;
  const [branchSelected, setBranchSelected] = React.useState(branchView);
  const [textBranchSelected, setTextBranchSelected] = React.useState((!!branchView?branchView.name +" - "+branchView.id:""));

  const [branchLocation, setBranchLocation] = React.useState();

  React.useEffect(()=>{
    //console.log("firebase")
    setSuccessLoadCompany(false)
    return firebase.fs.collection("companies").onSnapshot((querySnapshot) => {
      var datas = [];
      querySnapshot.forEach(function(doc) {
          var dat=doc.data()
          datas.push(dat);
      });
      setSuccessLoadCompany(true)
      setListCompanies(datas)
      setCompanySelected(companyView)
      setTextCompanySelected((!!companyView?companyView.name +" - "+companyView.id:""))
    },(e)=>{
      console.log(e)
      setListCompanies([])
      setCompanySelected(null)
      setTextCompanySelected("")
    })
  },[firebase,companyView])

  React.useEffect(()=>{
    //console.log("firebase,companySelected"+!companySelected)
    if(!companySelected){
      setBranchSelected(null)
      setTextBranchSelected("")
      setListBranches([])
      setSuccessLoadBranch(true)
      return
    }
    setSuccessLoadBranch(false)
    return firebase.fs.collection("companies/"+companySelected.id+"/branches").onSnapshot((querySnapshot) => {
      var datas = [];
      querySnapshot.forEach(function(doc) {
          var dat=doc.data()
          datas.push(dat);
      });
      setListBranches(datas)
      setSuccessLoadBranch(true)
      if(!!companyView&&companySelected.id===companyView.id){
        setBranchSelected(branchView)
        setTextBranchSelected((!!branchView?branchView.name +" - "+branchView.id:""))
      }else{
        setBranchSelected(null)
        setTextBranchSelected("")
      }
      
    },(e)=>{
      console.log(e)
      setListBranches([])
      if(!!companyView&&companySelected.id===companyView.id){
        setBranchSelected(null)
        setTextBranchSelected("")
      }
      
    })
  },[firebase,companySelected,companyView,branchView])
  

  function saveCompany(){
    firebase.fs.doc("users/"+currentUser.id).set({companyView:companySelected.id,},{merge:true})
    .then(()=>{
      console.log("ok")
    }).catch((e)=>{
      console.log(e)
    })
  }
  function saveBranch(){
    firebase.fs.doc("users/"+currentUser.id).set({branchView:branchSelected.id,},{merge:true})
    .then(()=>{
      console.log("ok")
    }).catch((e)=>{
      console.log(e)
    })
  }
  function saveAll(){
    firebase.fs.doc("users/"+currentUser.id).set({companyView:companySelected.id,branchView:branchSelected.id,},{merge:true})
    .then(()=>{
      console.log("ok")
    }).catch((e)=>{
      console.log(e)
    })
  }
  function clearAll(){
    firebase.fs.doc("users/"+currentUser.id).set({companyView:"",branchView:"",},{merge:true})
    .then(()=>{
      console.log("ok")
    }).catch((e)=>{
      console.log(e)
    })
  }
        

  return (
    <div className={classes.root}>
      <h1>HomePage</h1>
      
      currentUser : {!!currentUser?currentUser.name:null}<br />
      companyView : {!!companyView?companyView.name:null}<br />
      branchView : {!!branchView?branchView.name:null}<br />
      employeeData : {!!employeeData?employeeData.branchName+ "=>"+(!!employeeData.accessList?employeeData.accessList.length:0):null}<br />
      sessionDomain : {sessionDomain}<br/>
      domainExpirationStatus : {domainExpirationStatus}<br/>
      featureStatus : {featureStatus}<br/>
      errorPosition : <span style={{color:"red"}}>{errorPosition}</span><br />
      <Autocomplete
        autoComplete
        open={openCompany}
        onOpen={() => {
          setOpenCompany(true);
        }}
        onClose={() => {
          setOpenCompany(false);
        }}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name +" - "+option.id}
        options={listCompanies}
        loading={loadingCompany}
        value={companySelected}
        onChange={(event, newValue) => {
          setCompanySelected(newValue);
          if(!!newValue){
            //save to user firestore
          }
        }}
        inputValue={textCompanySelected}
        onInputChange={(event,value)=>{
          setTextCompanySelected(value)
        }}
        renderInput={(params) => <TextField {...params}
          margin="dense"
          label={"Pilih Merk / Perusahaan"}
          type="text"
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingCompany ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          />}
      />


      <Autocomplete
        autoComplete
        open={openBranch}
        onOpen={() => {
          setOpenBranch(true);
        }}
        onClose={() => {
          setOpenBranch(false);
        }}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name +" - "+option.id}
        options={listBranches}
        loading={loadingBranch}
        value={branchSelected}
        onChange={(event, newValue) => {
          setBranchSelected(newValue);
          if(!!newValue){
            //save to user firestore
          }
        }}
        inputValue={textBranchSelected}
        onInputChange={(event,value)=>{
          setTextBranchSelected(value)
        }}
        renderInput={(params) => <TextField {...params}
          margin="dense"
          label={"Pilih Cabang Perusahaan"}
          type="text"
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingBranch ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          />}
      />
    <Button onClick={saveCompany}>saveCompany</Button>
    <Button onClick={saveBranch}>saveBranch</Button>
    <Button onClick={saveAll}>saveAll</Button>
    <Button onClick={clearAll}>clearAll</Button>
    <Button onClick={()=>{firebase.doSignOut()}}>Log out</Button>
    <Link to={ROUTES.APPOINTMENT}>Lanjut ke Appointment</Link>

    <hr />
      <Typography>{!!branchLocation?"Posisi : Lat"+branchLocation.lat+" Lng"+branchLocation.lng:"Pilih lokasi terdekat!"}</Typography>
      <MapDialog data={[
        {id:"111",name:"nama 1",test:1,lat:-7.345270402982576,lng:112.74520710539785,},
        {id:"222",name:"nama 2",test:2,lat:-7.355270402982576,lng:112.74520710539785,},
        {id:"333",name:"nama 3",test:3,lat:-7.365270402982576,lng:112.74520710539785,},
        {id:"444",name:"nama 4",test:4,lat:-7.375270402982576,lng:112.74520710539785,},
        
        ]} title="Pilih Peta" initialSelectedMarker={branchLocation} onSelection={setBranchLocation}
        mode={1}/>
      <MapDialog data={[
        {id:"111",name:"nama 1",test:1,lat:-7.345270402982576,lng:112.74520710539785,},
        {id:"222",name:"nama 2",test:2,lat:-7.355270402982576,lng:112.74520710539785,},
        {id:"333",name:"nama 3",test:3,lat:-7.365270402982576,lng:112.74520710539785,},
        {id:"444",name:"nama 4",test:4,lat:-7.375270402982576,lng:112.74520710539785,},
        
        ]} title="Pilih Peta" initialSelectedMarker={branchLocation} onSelection={setBranchLocation}
        mode={2}/>
      <MapDialog data={[
        {id:"111",name:"nama 1",test:1,lat:-7.345270402982576,lng:112.74520710539785,},
        {id:"222",name:"nama 2",test:2,lat:-7.355270402982576,lng:112.74520710539785,},
        {id:"333",name:"nama 3",test:3,lat:-7.365270402982576,lng:112.74520710539785,},
        {id:"444",name:"nama 4",test:4,lat:-7.375270402982576,lng:112.74520710539785,},
        
        ]} title="Pilih Peta" initialSelectedMarker={branchLocation} onSelection={setBranchLocation}
        mode={3}/>
      
    </div>
  )
}

/*
<Map height="400px"
        data={[
          {id:"111",name:"nama 1",test:1,lat:-7.345270402982576,lng:112.74520710539785,},
          {id:"222",name:"nama 2",test:2,lat:-7.355270402982576,lng:112.74520710539785,},
          {id:"333",name:"nama 3",test:3,lat:-7.365270402982576,lng:112.74520710539785,},
          {id:"444",name:"nama 4",test:4,lat:-7.375270402982576,lng:112.74520710539785,},
          
        ]}
      />
*/
//<MapContainer data={listBranches} style={{height:"200px"}} onMapClicked={()=>{}} freeSelectMod={false}/>
const condition = authUser => !!authUser;
export default withAuthDomain(condition,ROUTES.LANDING,"online-asset-manager","")(withWidth()(HomePage));